export default __webpack_public_path__ + "static/media/DAX_logo_white.1ed585a6.png";